"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var debounce_event_1 = require("./debounce-event");
exports.default = debounce_event_1.default;
